<template>
  <div class="page-main">
    <e-tabs v-if="isLoadTab" :list="statusList" :activeVal.sync="bill_status1" />
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <el-button type="success" size="mini" icon="el-icon-plus" @click="itemAdd"
          >新增工程协同
        </el-button>
        <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
          <span>申请日期:</span>
          <e-date-picker
            type="daterange"
            :value.sync="filterData.create_date"
            isShowFast
            @change="searchListData"
          />
        </el-form>
      </div>
    </div>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 184"
      @cell-dblclick="itemDbDo"
      @resizable-change="handleColumnResize"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          @change="headerFilterChange"
        />
      </template>
      <template #header_daterange="{ column }">
        <c-table-header
          type="daterange"
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :value.sync="filterData.create_date"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_xie_tong_bill_code="{ row }">
        <el-link type="primary" @click="itemDo(row.id)"> {{ row.xie_tong_bill_code }} </el-link>
      </template>
      <template #default_zhi_zao_ming_xi="{ row }">
        <el-link type="primary" @click="itemMadeDetail(row.check_bill_id)">
          <div class="flex flex-y-center">
            <span class="iconfont icon-dingdan f-s-12"></span>
            <span>制造明细</span>
          </div>
        </el-link>
      </template>
      <template #default_zhi_zao_liu_cheng="{ row }">
        <el-link type="primary" @click="itemMadeView(row.check_bill_id)">
          <div class="flex flex-y-center">
            <span class="iconfont icon-ziliucheng f-s-12"></span>
            <span class="m-l-2">制造流程</span>
          </div>
        </el-link>
      </template>
      <template #default_jiao_huo_ri_qi="{ row }">
        {{ row.jiao_huo_ri_qi ? row.jiao_huo_ri_qi.slice(0, 10) : '' }}
      </template>
      <template #default_create_date="{ row }">
        {{ row.create_date ? row.create_date.slice(0, 10) : '' }}
      </template>
      <template #default_bu_men_name="{ row }">
        {{ row.bu_men_name.join('>') }}
      </template>
      <template #default_xie_tong_user_name="{ row }">
        <div>{{ row.xie_tong_user_name || '-' }}</div>
      </template>

      <template #default_fu_jian_file="{ row }">
        <e-upload-file v-if="row.fu_jian_file" :list.sync="row.fu_jian_file" disabled />
      </template>
      <template #default_qi_ta_yao_qiu="{ row }">
        <div class="text-overflow-3" :title="row.qi_ta_yao_qiu">
          {{ row.qi_ta_yao_qiu || '-' }}
        </div>
      </template>
      <template #default_qi_wang_date2="{ row }">
        <div>{{ row.qi_wang_date2 ? row.qi_wang_date2.slice(0, 10) : '-' }}</div>
        <div
          v-if="
            row.qi_wang_date2 &&
            row.qi_wang_date_str &&
            row.qi_wang_date_str !== '超期0天' &&
            (row.xie_tong_status_str === '待处理' || row.xie_tong_status_str === '处理中')
          "
          class="c-orange"
        >
          ({{ row.qi_wang_date_str || '-' }})
        </div>
      </template>
      <template #default_yu_ji_gong_shi="{ row }">
        <span v-if="row.yu_ji_gong_shi">{{ row.yu_ji_gong_shi }}小时</span>
        <span v-else>-</span>
      </template>
      <template #default_yu_ji_wan_gong="{ row }">
        <div v-if="row.xie_tong_status_str === '已完成'">
          <div>{{ row.wan_cheng_date ? row.wan_cheng_date.slice(0, 16) : '' }}</div>
          <div class="c-green">(完成时间)</div>
        </div>
        <div v-else>
          <div>{{ row.yu_ji_wan_gong ? row.yu_ji_wan_gong.slice(0, 16) : '-' }}</div>
          <div class="c-orange" v-if="row.yu_ji_wan_gong && row.yu_ji_wan_gong_str !== '超期0天'">
            ({{ row.yu_ji_wan_gong_str }})
          </div>
        </div>
      </template>
      <template #default_xie_tong_status_str="{ row }">
        <el-tag size="mini" :type="getStatusType(row.xie_tong_status_str)">
          {{ row.xie_tong_status_str }}
        </el-tag>
      </template>
      <template #default_operate="{ row }">
        <el-dropdown>
          <el-button type="default" size="mini">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="row.xie_tong_status_str === '待处理' && row.isFuZe"
              @click.native="itemDo(row.id)"
            >
              <span class="c-blue">确认处理</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="row.xie_tong_status_str === '处理中' && row.isFuZe"
              @click.native="itemDo(row.id)"
            >
              <span class="c-blue">继续处理</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="row.xie_tong_status_str === '处理中' && row.isFuZe"
              @click.native="itemFinish(row)"
            >
              <span class="c-green">确认完成</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="
                (row.xie_tong_status_str === '待处理' || row.xie_tong_status_str === '处理中') &&
                row.isChuangJian
              "
              @click.native="itemCancel(row)"
            >
              <span class="c-red">取消</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemDo(row.id)">
              <span>查看详情</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-新增 -->
    <PopupAdd v-if="isShowPopupAdd" :show.sync="isShowPopupAdd" @success="searchListData" />

    <!-- 弹窗-新增工程协同 -->
    <PopupXieTongDo
      v-if="isShowPopupXieTongDo"
      :show.sync="isShowPopupXieTongDo"
      :xietongId="activeXieTongId"
      @success="searchListData"
    />

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="activeBillId"
    />

    <!-- 弹窗-制造流程 -->
    <b-popup-verify-goods-view
      v-if="isShowPopupVerifyGoodsView"
      :show.sync="isShowPopupVerifyGoodsView"
      :id="activeBillId"
    />
  </div>
</template>

<script>
import PopupAdd from '../common/popup-add'
import PopupXieTongDo from '../../verify/common/popup-verify-do/index-xietong'
export default {
  tableName: 'new_xietong_page_list',
  components: {
    PopupAdd,
    PopupXieTongDo
  },
  data() {
    return {
      loading: true,
      isLoadTab: false,

      // filter
      bill_status1: '全部',
      filterData: {
        id: '',
        xie_tong_bill_code: '',
        check_bill_code: '',
        jiao_huo_ri_qi: '',
        create_date: [this.$util.getDate().monthStart, this.$util.getDate().monthEnd],
        create_name: '',
        bu_men_name: '',
        xie_tong_saler_company_name: '',
        xie_tong_company_name: '',
        xie_tong_user_name: '',
        qi_ta_yao_qiu: '',
        qi_wang_date2: '',
        yu_ji_gong_shi: '',
        yu_ji_wan_gong: ''
      },
      sortData: {
        id: 'desc'
      },

      // table
      headerFilterUrl: '/admin/gcvip/gongChengXieTong/searchHeard',
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        dai_chu_li_count: '',
        chu_li_zhong_count: '',
        yi_wan_cheng_count: '',
        yi_qu_xiao_count: ''
      },

      isShowPopupAdd: false,
      isShowPopupXieTongDo: false,
      isShowPopupVerifyGoodsDetail: false,
      isShowPopupVerifyGoodsView: false,
      activeXieTongId: null
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    accountId() {
      return this.$store.state.loginAccount.id
    },
    statusList() {
      let result = [
        {
          key: '全部',
          val: '全部',
          type: 'info'
        },
        {
          key: '待处理',
          val: '待处理',
          count: this.totalObj.dai_chu_li_count,
          type: 'warning',
          isRed: true
        },
        {
          key: '处理中',
          val: '处理中',
          count: this.totalObj.chu_li_zhong_count,
          type: 'primary'
        },
        {
          key: '已完成',
          val: '已完成',
          count: this.totalObj.yi_wan_cheng_count,
          type: 'success'
        },
        {
          key: '已取消',
          val: '已取消',
          count: this.totalObj.yi_qu_xiao_count,
          type: 'info'
        }
      ]
      return result
    },
    // 表格列配置
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '工程协同号',
          field: 'xie_tong_bill_code',
          slots: { header: 'header_input', default: 'default_xie_tong_bill_code' },
          width: 100
        },
        {
          title: '销售单号',
          field: 'check_bill_code',
          slots: { header: 'header_input' }
        },
        {
          title: '制造明细',
          slots: { default: 'default_zhi_zao_ming_xi' }
        },
        {
          title: '制造流程',
          slots: { default: 'default_zhi_zao_liu_cheng' }
        },
        {
          title: '订单类型',
          field: 'ding_dan_lei_xing',
          slots: { header: 'header_input' }
        },
        {
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          slots: { header: 'header_input', default: 'default_jiao_huo_ri_qi' }
        },
        {
          title: '申请日期',
          field: 'create_date',
          slots: { header: 'header_daterange', default: 'default_create_date' },
          width: 180
        },
        {
          title: '申请人',
          field: 'create_name',
          slots: { header: 'header_input' }
        },
        {
          title: '部门',
          field: 'bu_men_name',
          slots: { header: 'header_input', default: 'default_bu_men_name' }
        },
        {
          title: '开单公司',
          field: 'xie_tong_saler_company_name',
          slots: { header: 'header_input' },
          width: 180
        },
        {
          title: '客户',
          field: 'xie_tong_company_name',
          slots: { header: 'header_input' },
          width: 180
        },
        {
          title: '协同工程师',
          field: 'xie_tong_user_name',
          slots: { header: 'header_input', default: 'default_xie_tong_user_name' }
        },
        {
          title: '附件文档',
          field: 'fu_jian_file',
          slots: { default: 'default_fu_jian_file' }
        },
        {
          title: '其他要求',
          field: 'qi_ta_yao_qiu',
          slots: { header: 'header_input', default: 'default_qi_ta_yao_qiu' }
        },
        {
          title: '期望交期',
          field: 'qi_wang_date2',
          slots: { header: 'header_input', default: 'default_qi_wang_date2' }
        },
        {
          title: '预计工时',
          field: 'yu_ji_gong_shi',
          slots: { header: 'header_input', default: 'default_yu_ji_gong_shi' }
        },
        {
          title: '预计完工',
          field: 'yu_ji_wan_gong',
          slots: { header: 'header_input', default: 'default_yu_ji_wan_gong' }
        },
        {
          title: '状态',
          slots: { default: 'default_xie_tong_status_str' },
          width: 60
        },
        {
          fixed: 'right',
          title: '操作',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result)
      return result
    }
  },
  watch: {
    bill_status1() {
      this.searchListData()
    }
  },
  mounted() {
    this.isLoadTab = false
    if (this.$route.query.status) {
      this.bill_status1 = this.$route.query.status
    } else {
      this.getListData()
    }
    this.isLoadTab = true
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 获取状态类型
    getStatusType(val) {
      let result = ''
      this.statusList.forEach((item) => {
        if (item.val === val) result = item.type
      })
      return result
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let filterData = this.$util.deepCopy(this.filterData)
      if (!filterData.id) delete filterData.id
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongChengXieTong/list',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          bill_status1: this.bill_status1 === '全部' ? '' : this.bill_status1,
          filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            list.forEach((item) => {
              item.isChuangJian = this.isAdmin || item.create_name_id === this.accountId
              item.isFuZe = this.isAdmin || item.xie_tong_user_id === this.accountId
            })
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.dai_chu_li_count = res.data.dai_chu_li_count
            this.totalObj.chu_li_zhong_count = res.data.chu_li_zhong_count
            this.totalObj.yi_wan_cheng_count = res.data.yi_wan_cheng_count
            this.totalObj.yi_qu_xiao_count = res.data.yi_qu_xiao_count
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 项新增
    itemAdd() {
      this.isShowPopupAdd = true
    },
    // 项-增改
    itemDo(id = null) {
      this.activeXieTongId = id
      this.isShowPopupXieTongDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.id)
    },
    // 项-提交
    itemPush(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/salerDoAudit',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('工程协同已提交')
          this.getListData()
        }
      })
    },
    // 项-取消
    itemCancel(row) {
      this.$confirm(`您确定要取消“${row.xie_tong_bill_code}”的工程协同吗?`, '取消确认')
        .then(() => {
          this.itemCancelConfirm(row.id)
        })
        .catch(() => {})
    },
    // 项-取消-确认
    itemCancelConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong/doQuXiao',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('工程协同已取消')
          this.getListData()
        }
      })
    },
    // 项-确认完成
    itemFinish(row) {
      this.$confirm(`您确定要完成“${row.xie_tong_bill_code}”的工程协同任务吗?`, '完成确认')
        .then(() => {
          this.itemFinishConfirm(row.id)
        })
        .catch(() => {})
    },
    // 项-确认完成-确认
    itemFinishConfirm(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong/doWanCheng',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('工程协同已确认完成')
          this.getListData()
        }
      })
    },
    // 项-制造明细
    itemMadeDetail(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 项-制造流程
    itemMadeView(id) {
      this.activeBillId = id
      this.isShowPopupVerifyGoodsView = true
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
